/**
 * OpcReportHost — listens for `generate-opc-report` (detail.projectId, detail.preview?) and renders the
 * native Owner's Project Criteria PDF, opening it in a new tab. Mounted once in OutlineView. Dispatched
 * from the Criteria/Documents ⋯ actions. Mirrors PreDesignReportHost.
 */
import { useEffect, useState } from 'react'
import { generateOpcReport, previewOpcReport } from '../services/opc.js'
import { alertDialog } from './Dialog.jsx'

export default function OpcReportHost() {
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    async function onGen(e) {
      const projectId = e && e.detail && e.detail.projectId
      if (!projectId) { await alertDialog({ title: 'No project', message: 'Could not resolve the project for this report.' }); return }
      if (busy) return
      setBusy(true)
      const tab = window.open('', '_blank')   // open synchronously so the browser doesn't block it
      try {
        const res = await (e.detail && e.detail.preview ? previewOpcReport(projectId) : generateOpcReport(projectId))
        if (res.error) { if (tab) tab.close(); await alertDialog({ title: 'Report failed', message: res.error }) }
        else if (tab) tab.location = res.pdfUrl
        else window.open(res.pdfUrl, '_blank')
      } catch (err) {
        if (tab) tab.close()
        await alertDialog({ title: 'Report failed', message: (err && err.message) || 'Could not generate the report.' })
      }
      setBusy(false)
    }
    window.addEventListener('generate-opc-report', onGen)
    return () => window.removeEventListener('generate-opc-report', onGen)
  }, [busy])

  return null
}
